import I18n from 'I18n';
import enviro from 'enviro';

import {
  updateAnthropicApiKey,
  updateCohereApiKey,
  updateGeminiApiKey,
  updateOpenaiApiKey,
  updateXaiApiKey,
} from './requests';
import { errorNotificationAlert, successNotificationAlert } from './alerts';

type TApiKeyUpdateRequest =
  | typeof updateAnthropicApiKey
  | typeof updateCohereApiKey
  | typeof updateGeminiApiKey
  | typeof updateOpenaiApiKey
  | typeof updateXaiApiKey;

type TApiRequestHandlerParams = {
  apiKey: string;
  onSuccess: () => void;
  onFailure?: (errorMessage: string) => void;
};

const createUpdateApiKeyRequestHandler =
  (updateApiKey: TApiKeyUpdateRequest) =>
  async ({ apiKey, onSuccess, onFailure }: TApiRequestHandlerParams) => {
    try {
      const response = await updateApiKey({
        apiKey,
      });

      if (!('error' in response)) {
        successNotificationAlert();
        onSuccess();
        return;
      }

      errorNotificationAlert();
      onFailure?.(response.error.chirpErrorMessage);
    } catch (error) {
      if (enviro.isQa()) {
        console.error('Failed to update API key:', error);
      }
      onFailure?.(
        I18n.text(
          'reconnect.aiReconnectModal.validationMessages.apiKeyGenericError'
        )
      );
    }
  };

export const handleAnthropicApiKeyUpdate = createUpdateApiKeyRequestHandler(
  updateAnthropicApiKey
);

export const handleCohereApiKeyUpdate =
  createUpdateApiKeyRequestHandler(updateCohereApiKey);

export const handleGeminiApiKeyUpdate =
  createUpdateApiKeyRequestHandler(updateGeminiApiKey);

export const handleOpenaiApiKeyUpdate =
  createUpdateApiKeyRequestHandler(updateOpenaiApiKey);

export const handleXaiApiKeyUpdate =
  createUpdateApiKeyRequestHandler(updateXaiApiKey);
